import { createIcon } from '../../createIcon';
import { withIcon } from '../../withIcon';
import { LockSvg } from './Lock';

export const LockIcon = createIcon('lock', LockSvg);
/**
 * @deprecated используйте LockIcon
 */
export const withLockIcon = withIcon('lock', LockSvg);
